exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-image-picker-preview-image {\n  width: 110px !important;\n  height: 110px !important;\n  text-align: center;\n}\n.v-image-picker-preview-image .el-icon-document {\n    font-size: 40px;\n    margin-top: 35px;\n    color: #aaa;\n}\n", ""]);

// exports
